import { AdditionalContactFormData } from "./types";

export const isContractorContact = (contact: AdditionalContactFormData | undefined): boolean => !!contact?.origId;
